var getCtaLink = function (item) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    if ('ctaLink' in item) {
        return {
            linktype: (_a = item === null || item === void 0 ? void 0 : item.ctaLink) === null || _a === void 0 ? void 0 : _a.linktype,
            href: (_b = item === null || item === void 0 ? void 0 : item.ctaLink) === null || _b === void 0 ? void 0 : _b.href,
            target: (_c = item === null || item === void 0 ? void 0 : item.ctaLink) === null || _c === void 0 ? void 0 : _c.target,
            querystring: (_d = item === null || item === void 0 ? void 0 : item.ctaLink) === null || _d === void 0 ? void 0 : _d.querystring,
            // TODO: Ensure related components use text field instead of title
            title: ((_e = item === null || item === void 0 ? void 0 : item.ctaLink) === null || _e === void 0 ? void 0 : _e.title) || ((_f = item === null || item === void 0 ? void 0 : item.ctaLink) === null || _f === void 0 ? void 0 : _f.text),
            text: (_g = item === null || item === void 0 ? void 0 : item.ctaLink) === null || _g === void 0 ? void 0 : _g.text,
        };
    }
    if ('cta' in item) {
        return {
            linktype: (_h = item === null || item === void 0 ? void 0 : item.cta) === null || _h === void 0 ? void 0 : _h.linktype,
            href: (_j = item === null || item === void 0 ? void 0 : item.cta) === null || _j === void 0 ? void 0 : _j.href,
            target: (_k = item === null || item === void 0 ? void 0 : item.cta) === null || _k === void 0 ? void 0 : _k.target,
            querystring: (_l = item === null || item === void 0 ? void 0 : item.cta) === null || _l === void 0 ? void 0 : _l.querystring,
            title: (_m = item === null || item === void 0 ? void 0 : item.cta) === null || _m === void 0 ? void 0 : _m.title,
            text: (_o = item === null || item === void 0 ? void 0 : item.cta) === null || _o === void 0 ? void 0 : _o.text,
        };
    }
};
export default getCtaLink;
